<flx-resources-grid
  [hasBackground]="false"
  [tableDef]="subprocessesTableCols"
  [items]="items()"
  emptyMsg="No subprocesses"
  emptyMsgDescription="Subprocess instances started by this instance appear here."
  emptyMsgIcon="ph ph-tree-structure"
/>
